/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, TextField, Typography, Divider } from '@mui/material';

const TripDetailsSection = ({ formik, selectedPlan, isMobile }) => (
    <>
        <Grid item xs={12}>
            <Typography variant="subtitle1" gutterBottom>
                Trip Details
            </Typography>
            <Divider />
        </Grid>

        {/* Trip Purpose */}
        <Grid item xs={12} md={6}>
            <TextField
                label="Trip Purpose"
                fullWidth
                value={selectedPlan?.planName || ''}
                disabled
                sx={{
                    '& .MuiInputBase-input.Mui-disabled': {
                        WebkitTextFillColor: '#000000'
                    }
                }}
            />
        </Grid>

        {/* Travel Type */}
        <Grid item xs={12} md={6}>
            <TextField
                label="Travel Type"
                fullWidth
                value={
                    selectedPlan?.type === 'LUNCH_INCLUDED'
                        ? 'Lunch is Covered by Host/Organizer'
                        : 'Need to Claim Lunch Allowance'
                }
                disabled
                sx={{
                    '& .MuiInputBase-input.Mui-disabled': {
                        WebkitTextFillColor: '#000000'
                    }
                }}
            />
        </Grid>

        {/* Departure DateTime */}
        <Grid item xs={12} md={6}>
            <TextField
                name="departureDatetime"
                label="Departure Date & Time"
                type="datetime-local"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={formik.values.departureDatetime}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.departureDatetime && Boolean(formik.errors.departureDatetime)}
                helperText={formik.touched.departureDatetime && formik.errors.departureDatetime}
            />
        </Grid>

        {/* Return DateTime */}
        <Grid item xs={12} md={6}>
            <TextField
                name="returnDatetime"
                label="Return Date & Time"
                type="datetime-local"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={formik.values.returnDatetime}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.returnDatetime && Boolean(formik.errors.returnDatetime)}
                helperText={formik.touched.returnDatetime && formik.errors.returnDatetime}
            />
        </Grid>
    </>
);

TripDetailsSection.propTypes = {
    formik: PropTypes.object.isRequired,
    selectedPlan: PropTypes.object,
    isMobile: PropTypes.bool.isRequired
};

export default TripDetailsSection; 